import {
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemButtonProps,
  ListItemIcon,
  Typography,
} from '@mui/material';
import Icon from '../IconSvg/Icon';

export type ClickableListItemProps = ListItemButtonProps & {
  primary: string;
  secondary?: string;
  primaryIcon?: React.ReactNode;
  showChevron?: boolean;
};

export const ClickableListItem = ({
  primary,
  secondary,
  primaryIcon,
  showChevron = true,
  onClick,
  ...props
}: ClickableListItemProps) => {
  return (
    <ListItem disablePadding>
      <ListItemButton
        dense
        onClick={onClick}
        disableRipple
        sx={{ gap: 2 }}
        {...props}
      >
        {primaryIcon && <ListItemIcon>{primaryIcon}</ListItemIcon>}

        <ListItemText
          primary={
            <Typography variant="body2" color="inherit">
              {primary}
            </Typography>
          }
          secondary={
            <Typography variant="body2" color="text.secondary">
              {secondary}
            </Typography>
          }
        />

        {showChevron && (
          <ListItemIcon>
            <Icon
              name="lely-icon-chevron-right"
              style={{ width: 24, height: 24 }}
            />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
};
